<template>
  <div class="gift">
    <!-- <app-gifts-banner/> -->

    <div
      style="margin-bottom: 100px"
      v-if="currentTags && currentTags.find((t) => t.tag === 'Location Russia')"
    >
      <span class="announcement"
        >Loyalty shop временно не работает по техническим причинам</span
      >
    </div>

    <div
      style="margin-bottom: 100px"
      v-else-if="remoteConfig && remoteConfig.closedCities.includes(city)"
    >
      <span class="announcement">{{ remoteConfig.closedCitiesText }}</span>
    </div>

    <div v-else>
      <div class="wrapper">
        <div class="tabs">
          <div
            class="tab"
            :class="{ active: currentTab == 'default' }"
            @click="currentTab = 'default'"
          >
            <span class="name"> Rewards </span>
            <span class="points">
              {{ currentPoints }}
              {{ currentPoints | pluralize("point,points,points") }}
            </span>
          </div>
          <div
            class="tab"
            :class="{ active: currentTab == 'education' }"
            @click="currentTab = 'education'"
            v-if="
              !(
                remoteConfig &&
                remoteConfig.learningDisabled &&
                remoteConfig.learningDisabled.includes(city)
              )
            "
          >
            <span class="name"> Learning </span>
            <span class="points" v-if="p2pConfig['edu']">
              {{ p2pConfig["edu"].points || 0 }}
              {{ p2pConfig["edu"].points | pluralize("point,points,points") }}
            </span>
          </div>
        </div>
      </div>
      <div v-for="(group, index) in groupedGiftList(currentTab)" :key="index">
        <div
          class="wrapper"
          v-if="
            remoteConfig &&
            (remoteConfig.gifts[group.id || 'default'].title ||
              remoteConfig.gifts[group.id || 'default'].subtitle)
          "
        >
          <span
            class="block-head"
            v-if="
              remoteConfig && remoteConfig.gifts[group.id || 'default'].title
            "
            >{{
              remoteConfig && remoteConfig.gifts[group.id || "default"].title
            }}</span
          >
          <span
            class="block-desc"
            v-if="
              remoteConfig && remoteConfig.gifts[group.id || 'default'].subtitle
            "
            >{{
              remoteConfig && remoteConfig.gifts[group.id || "default"].subtitle
            }}</span
          >
        </div>

        <div class="line-wrap" ref="categoryBar">
          <div
            class="wrapper"
            v-if="isInited && filteredGiftList && filteredGiftList.length"
          >
            <div class="coll">
              <div
                v-for="(gift, index) in group.gifts"
                :key="index"
                :ref="'gift_' + gift.id"
                class="gift-item"
                @click.prevent="openGift(gift)"
              >
                <div class="img">
                  <progressive-img class="img-content" :src="giftImage(gift)" />
                </div>
                <div class="info">
                  <span class="name" @click.prevent="openGift(gift)">{{
                    giftName(gift)
                  }}</span>
                  <span class="ball crossed" v-if="isDiscounted(gift)"
                    >{{ Math.floor((gift.points * 2) / 5) * 5 }}
                    {{ gift.points | pluralize("point,points,points") }}</span
                  >
                  <span
                    class="ball"
                    :class="{ discounted: isDiscounted(gift) }"
                    v-if="!isCharity(gift)"
                    >{{ gift.points }}
                    {{ gift.points | pluralize("point,points,points") }}</span
                  >
                </div>

                <div class="gift-hover">
                  <div class="center">
                    <span class="name">{{ giftName(gift) }}</span>
                    <div class="desc" v-html="gift.description"></div>
                  </div>
                  <a
                    v-if="
                      (gift.points <= currentPoints && !isCharity(gift)) ||
                      currentTab === 'education'
                    "
                    href="#"
                    class="red-btn"
                    >Get for {{ gift.points }}
                    {{ gift.points | pluralize("point,points,points") }}</a
                  >
                  <a v-else-if="isCharity(gift)" href="#" class="red-btn"
                    >Donate</a
                  >
                  <span v-else class="red-btn red-btn-dis"
                    >Need another {{ gift.points - currentPoints }}
                    {{
                      (gift.points - currentPoints)
                        | pluralize("point,points,points")
                    }}</span
                  >
                </div>
                <div class="plaque orange" v-if="giftPlaque(gift)">{{giftPlaque(gift)}}</div>
                <div class="plaque orange" v-if="isDiscounted(gift)">-50%</div>
                <div class="plaque green" v-if="isNew(gift)">NEW</div>
                <div class="plaque red" v-if="isP2PGiftEnabled(gift)">
                  MAKE A GIFT
                </div>
                <div class="plaque green" v-if="isEco(gift)">ECO</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="link-wrap">
      <a
        class="link"
        href="https://sailplays3.cdnvideo.net/media/assets/assetfile/47d55efb99b7861efb311dbbff379250.pdf"
        target="_blank"
        >Terms and Conditions</a
      >
      <a
        class="link"
        style="margin-left: 40px"
        href="https://sailplays3.cdnvideo.net/media/assets/assetfile/ffcdd9e0cab46edb8a2398893cde0044.pdf"
        target="_blank"
        >Frequently Asked Questions</a
      >
      <a
        class="link"
        style="margin-left: 40px"
        href="./SP_GDPR_Compliance_Overview.pdf"
        >GDPR Compliance Overview</a
      >
      <a
        class="link"
        style="margin-left: 40px"
        href="https://sailplays3.cdnvideo.net/media/assets/assetfile/06681d0014cfd4030106a609d8026c56.pdf"
        target="_blank"
        >Gift Tax Information By Location</a
      >
      <a class="link" style="margin-left: 40px" href="./PrivacyPolicy.pdf"
        >Privacy Policy</a
      >
    </div>

    <transition name="s_popup_transition">
      <div v-if="gift && !success" class="popup">
        <div
          class="popup-inner popup-inner-gift"
          v-on-clickaway="hideGiftPopup"
        >
          <a href="#" class="close" @click.prevent="gift = false"></a>
          <div class="gift_info">
            <div class="info">
              <span class="name">{{ giftName(gift) }}</span>
              <div class="desc" v-html="gift.description"></div>
            </div>
            <div class="img">
              <img :src="giftImage(gift)" />
            </div>
          </div>

          <div class="gift_form">
            <span
              class="desc"
              style="margin-bottom: 10px; font-weight: bold"
              v-if="
                remoteConfig &&
                remoteConfig.sizedGifts.includes(gift.id) &&
                !isP2PGift
              "
            >
              Size:
            </span>
            <div
              class="popup-inner-transfer_input type_select"
              style="width: 100%; margin-bottom: 30px"
              v-if="
                remoteConfig &&
                remoteConfig.sizedGifts.includes(gift.id) &&
                !isP2PGift
              "
            >
              <select v-model="size">
                <option disabled selected value="">{{ defaultSize }}</option>
                <option
                  v-for="(option, index) in sizes.filter((size) =>
                    displayedSize(gift, size)
                  )"
                  :key="index"
                  :value="option"
                >
                  <span v-if="displayedSize(gift, option)">
                    {{ displayedSize(gift, option) }}</span
                  >
                </option>
              </select>
            </div>

            <span
              class="desc"
              style="margin-bottom: 10px; font-weight: bold"
              v-if="currentTab === 'education'"
            >
              Language:
            </span>
            <div
              class="popup-inner-transfer_input type_select"
              style="width: 100%"
              v-if="currentTab === 'education'"
            >
              <select v-model="language">
                <option disabled selected value="">Choose a language...</option>
                <option key="english" value="english">English</option>
                <option key="native" value="native">Native</option>
              </select>
            </div>
            <span
              class="desc"
              style="margin-bottom: 10px; font-size: 14px"
              v-if="language === 'native'"
            >
              <i>* Note: subject to availability</i>
            </span>

            <span
              class="desc"
              style="margin-bottom: 10px; font-weight: bold"
              v-if="isCharity(gift)"
            >
              Donation amount:
            </span>
            <input
              v-model="charity"
              type="number"
              min="1"
              max="100"
              class="popup-inner-transfer_input"
              style="width: 100%"
              v-if="isCharity(gift)"
            />

            <div
              class="checkbox_block"
              style="padding: 10px 0px"
              v-if="isP2PGiftEnabled(gift)"
            >
              <input type="checkbox" v-model="isP2PGift" />
              <span class="checkbox_text">
                Send as a gift to your colleague
              </span>
            </div>
            <div
              class="popup-inner-transfer_input_wrapper type_error"
              style="width: 308px"
              v-if="isP2PGift"
            >
              <input
                class="popup-inner-transfer_input"
                type="email"
                :placeholder="'Email address of your colleague'"
                v-model="email"
                @input="onInput"
              />
              <div
                v-if="validationStatus === 'error'"
                class="popup-inner-transfer_input_error_message"
              >
                <div class="popup-inner-transfer_input_error_message_popup">
                  Specified Email was not found
                </div>
              </div>
              <div
                v-if="validationStatus === 'ok'"
                class="popup-inner-transfer_input_success_message"
              />
              <input
                v-model="P2PGiftNote"
                type="text"
                class="popup-inner-transfer_input"
                style="width: 100%"
                placeholder="Wish"
              />
            </div>

            <div
              class="delivery"
              v-if="!isCharity(gift) && !isDeliveryDisabled(gift)"
              style="margin-top: 40px"
            >
              <span class="desc" style="margin-bottom: 10px; font-weight: bold">
                Delivery information:
              </span>

              <div
                class="popup-inner-transfer_input type_select"
                style="width: 100%"
              >
                <select v-model="delivery.type">
                  <option disabled selected value="">
                    Choose a delivery option
                  </option>
                  <option
                    v-if="
                      !(
                        disabledOptions &&
                        disabledOptions.includes('delivery_type.delivery')
                      )
                    "
                    key="delivery"
                    value="delivery"
                  >
                    Delivery
                  </option>
                  <option
                    v-if="
                      !(
                        disabledOptions &&
                        disabledOptions.includes('delivery_type.pickup')
                      )
                    "
                    key="pickup"
                    value="pickup"
                  >
                    Pick up at the office
                  </option>
                </select>
              </div>

              <span
                class="desc"
                style="margin-bottom: 10px; font-size: 14px"
                v-if="delivery.type === 'pickup'"
              >
                <i
                  >* Unavailable in some locations - please check with your
                  local EB manager</i
                >
              </span>

              <span
                v-else-if="delivery.type === 'delivery'"
                class="desc"
                style="margin-bottom: 10px; font-size: 14px"
              >
                <i
                  >* Make sure you include your full address and contact
                  information</i
                >
              </span>

              <input
                v-model="delivery.full_name"
                type="text"
                class="popup-inner-transfer_input"
                style="width: 100%"
                placeholder="Full name..."
                maxlength="30"
                v-if="delivery.type === 'delivery'"
              />
              <input
                v-model="delivery.address"
                type="text"
                class="popup-inner-transfer_input"
                style="width: 100%"
                placeholder="Address..."
                maxlength="120"
                v-if="delivery.type === 'delivery'"
              />
              <input
                v-model="delivery.postal"
                type="text"
                class="popup-inner-transfer_input"
                style="width: 100%"
                :placeholder="
                  locationManager !== 'employer_branding_ua@luxoft.com'
                    ? 'Postal code...'
                    : 'Nova Poshta #...'
                "
                max="10000000"
                v-if="delivery.type === 'delivery'"
              />
              <input
                v-model="delivery.city"
                type="text"
                class="popup-inner-transfer_input"
                style="width: 100%"
                maxlength="20"
                placeholder="City..."
                v-if="delivery.type === 'delivery'"
              />
              <input
                v-model="delivery.country"
                type="text"
                class="popup-inner-transfer_input"
                style="width: 100%"
                maxlength="20"
                placeholder="Country..."
                v-if="delivery.type === 'delivery'"
              />
              <input
                v-model="delivery.phone"
                type="text"
                class="popup-inner-transfer_input"
                style="width: 100%"
                maxlength="20"
                placeholder="Phone... (including country code +)"
                v-if="delivery.type === 'delivery'"
              />
              <input
                v-model="delivery.comment"
                type="text"
                class="popup-inner-transfer_input"
                style="width: 100%"
                maxlength="120"
                placeholder="Comment (optional)..."
              />
              <span
                class="desc"
                style="margin-bottom: 10px; font-weight: bold"
                v-if="currentTab == 'education'"
              >
                Loyalty wallet:
              </span>
              <div
                class="popup-inner-transfer_input type_select"
                style="width: 100%; margin-bottom: 30px"
                v-if="currentTab == 'education'"
              >
                <select v-model="wallet">
                  <option disabled selected value="null">
                    Choose a loyalty wallet...
                  </option>
                  <option
                    v-for="(option, index) in wallets"
                    :key="index"
                    :value="option"
                  >
                    {{ option.name }} - {{ option.points }}
                    {{ option.points | pluralize("point,points,points") }}
                  </option>
                </select>
              </div>

              <div class="checkbox_block" style="padding: 10px 0px">
                <input type="checkbox" v-model="delivery.retiring" />
                <span class="checkbox_text">
                  I'm leaving the company soon
                </span>
              </div>
              <span
                class="desc"
                style="margin: 20px 0 10px 0; font-size: 14px"
                v-if="delivery.retiring"
              >
                Final day:
              </span>
              <input
                v-model="delivery.retiringDate"
                type="date"
                min="2022-01-01"
                maxlength="10"
                class="popup-inner-transfer_input"
                style="width: 100%; margin-bottom: 20px"
                placeholder="Retirement date..."
                v-if="delivery.retiring"
              />

              <div class="checkbox_block" style="padding: 10px 0px">
                <input type="checkbox" v-model="delivery.vacation" />
                <span class="checkbox_text"> I'm going on vacation soon </span>
              </div>
              <span
                class="desc"
                style="margin: 20px 0 10px 0; font-size: 14px"
                v-if="delivery.vacation"
              >
                Vacation start:
              </span>
              <input
                v-model="delivery.vacationStart"
                type="date"
                min="2022-01-01"
                maxlength="10"
                class="popup-inner-transfer_input"
                style="width: 100%"
                placeholder="Vacation start..."
                v-if="delivery.vacation"
              />
              <span
                class="desc"
                style="margin-bottom: 10px; font-size: 14px"
                v-if="delivery.vacation"
              >
                Vacation end:
              </span>
              <input
                v-model="delivery.vacationEnd"
                type="date"
                min="2022-01-01"
                maxlength="10"
                class="popup-inner-transfer_input"
                style="width: 100%; margin-bottom: 20px"
                placeholder="Vacation end..."
                v-if="delivery.vacation"
              />

              <div class="checkbox_block" style="padding: 10px 0 10px 0">
                <input type="checkbox" v-model="delivery.agreements.main" />
                <span class="checkbox_text" v-html="getGiftAgreement" />
              </div>
              <div class="checkbox_block" style="padding: 0 0 40px 0">
                <input type="checkbox" v-model="delivery.agreements.tax" />
                <a
                  class="checkbox_text"
                  target="_blank"
                  href="https://sailplays3.cdnvideo.net/media/assets/assetfile/06681d0014cfd4030106a609d8026c56.pdf"
                  >I have checked the local regulations to see if there are
                  taxes associated with my order.</a
                >
              </div>

              <div
                class="checkbox_block"
                style="padding: 10px 0 10px 0"
                v-if="delivery.custom_agreement_text"
              >
                <input type="checkbox" v-model="delivery.agreements.custom" />
                <span
                  class="checkbox_text"
                  v-html="delivery.custom_agreement_text"
                />
              </div>
            </div>
            <a
              v-if="isEnoughPoints(gift)"
              @click.prevent="getGift(gift)"
              href="#"
              class="red-btn"
              :class="{ cancel: isRedemptionDisabled(gift) }"
              :disabled="isRedemptionDisabled(gift)"
              style="width: 100%; margin-top: 10px"
              >Submit</a
            >
            <span
              v-else
              class="red-btn red-btn-dis cancel"
              style="width: 100%; margin-top: 10px"
              >Not enough points</span
            >
          </div>
          <div class="bottom" v-if="!isCharity(gift)">
            Rewards can take up to 90 business days to be delivered.
            <br />
            Please check local regulation to see if your reward is subject to
            taxation.
            <a
              class="link"
              target="_blank"
              href="https://sailplays3.cdnvideo.net/media/assets/assetfile/06681d0014cfd4030106a609d8026c56.pdf"
              >Read more here.</a
            >
          </div>
        </div>
      </div>
    </transition>

    <transition name="s_popup_transition">
      <div v-if="gift && success" class="popup">
        <div
          class="popup-inner popup-inner-gift popup-inner-gift-congr"
          v-on-clickaway="hideGiftPopup"
        >
          <a
            href="#"
            class="close"
            @click.prevent="
              success = null;
              gift = null;
            "
          ></a>
          <div class="info">
            <span v-if="!isP2PGift && !isCharity(gift)" class="name"
              >Congratulations on your reward!</span
            >
            <span v-if="isP2PGift" class="name">Thank you!</span>
            <span v-if="isCharity(gift)" class="name"
              >Thank you for your donation!</span
            >
            <span class="desc" v-if="!isP2PGift && !isCharity(gift)"
              >The redemption request can take up to 90 business days to be
              processed, so we will contact you when your reward is ready.</span
            >
            <span class="desc" v-if="isP2PGift"
              >Your gift request has been successfully submitted. We'll start
              processing it soon to ensure that your bit of holiday cheer
              reaches your colleague.</span
            >
            <a
              href="#"
              @click.prevent="
                success = null;
                gift = null;
              "
              class="red-btn"
              >Continue</a
            >
          </div>
        </div>
      </div>
    </transition>

    <!-- Popup -->
    <!--
    <transition name="s_popup_transition">
      <div class="popup" v-if="isOpenPopup">
        <div
          class="popup-inner popup-inner-about"
          v-on-clickaway="
            () => {
              isOpenPopup = false;
            }
          "
        >
          <a href="#" class="close" @click.prevent="isOpenPopup = false"></a>
          <span class="head">Terms and Conditions</span>
          <div class="desk" v-html="remoteConfig.termsAndConditions" />
        </div>
      </div>
    </transition> -->

    <!-- Popup -->
    <!--
    <transition name="s_popup_transition">
      <div class="popup" v-if="isOpenFaq">
        <div
          class="popup-inner popup-inner-about"
          v-on-clickaway="
            () => {
              isOpenFaq = false;
            }
          "
        >
          <a href="#" class="close" @click.prevent="isOpenFaq = false"></a>
          <span class="head">Frequently Asked Questions</span>
          <div class="desk" v-html="remoteConfig.FAQ"></div>
        </div>
      </div>
    </transition>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import throttle from "lodash/throttle";
import { directive as onClickaway } from "vue-clickaway2";
import urlParams from "../helpers/getUrlParams";
import giftAgreement from "../helpers/giftAgreement";
import AppGiftsBanner from "./AppGiftsBanner";

const THROTTLE_SCROLL_TIME = 100;
const THROTTLE_LINE_UPDATE_TIME = 100;
const SIZES = ["XXS", "XS", "S", "M", "L", "XL", "XXL"];
const SIZE_DEPS = {
  XXS: "80761",
  XS: "80762",
  S: "72129",
  M: "72130",
  L: "72128",
  XL: "72131",
  XXL: "79128",
};
const DEFAULT_SIZE = "Choose a size...";
export default {
  name: "AppGifts",
  data() {
    return {
      isMobile: false,
      lineWidth: 0,
      isMounted: false,
      holding: false,
      fixed: false,
      gift: null,
      success: null,
      isOpenPopup: false,
      isOpenFaq: false,
      sizes: SIZES,
      defaultSize: DEFAULT_SIZE,
      size: "",
      charity: 0,
      email: "",
      P2PGiftNote: "",
      validationStatus: null,
      isP2PGift: false,
      defaultDelivery: null,
      currentTab: "default",
      delivery: {
        type: "",
        full_name: "",
        address: "",
        country: "",
        city: "",
        postal: "",
        phone: "",
        retiring: false,
        vacation: false,
        retiringDate: "",
        vacationStart: "",
        vacationEnd: "",
        custom_agreement_text: "",
        agreements: {
          main: false,
          tax: false,
          custom: true,
        },
        comment: "",
      },
      wallet: null,
      language: "",
    };
  },
  directives: {
    onClickaway,
  },
  components: {
    AppGiftsBanner,
  },
  computed: {
    ...mapGetters([
      "isInited",
      "currentUser",
      "currentPoints",
      "giftList",
      "remoteConfig",
      "p2pConfig",
      "currentVars",
      "currentTags",
      "locationManager",
      "city",
    ]),
    parsedGiftList() {
      return this.giftList;
    },
    sortedGiftList() {
      let giftList = this.parsedGiftList;
      return (
        giftList &&
        giftList.sort((a, b) =>
          this.remoteConfig["priorityOrderGifts"].includes(a.name) &&
          !this.remoteConfig["priorityOrderGifts"].includes(b.name)
            ? -1
            : this.remoteConfig["priorityOrderGifts"].includes(b.name) &&
              !this.remoteConfig["priorityOrderGifts"].includes(a.name)
            ? 1
            : a.points > b.points
            ? 1
            : a.points < b.points
            ? -1
            : a.name > b.name
            ? 1
            : -1
        )
      );
    },
    filteredGiftList() {
      return this.sortedGiftList;
    },
    getGiftAgreement() {
      return giftAgreement.getGiftAgreement(this.city);
    },
    agreement() {
      return Object.values(this.delivery.agreements).reduce(
        (acc, value) => acc && value
      );
    },
    wallets() {
      let wallets = [];

      if (this.p2pConfig["edu"]) {
        wallets.push({
          name: "Learning Wallet",
          points: this.p2pConfig["edu"].points || 0,
          auth_hash: this.p2pConfig["edu"].auth_hash,
        });
      }
      wallets.push({
        name: "Default Wallet",
        points: this.currentPoints,
        auth_hash: "default",
      });
      return wallets;
    },
    disabledOptions() {
      return this.remoteConfig && this.city in this.remoteConfig.disabledOptions
        ? this.remoteConfig.disabledOptions[this.city]
        : [];
    },
  },
  filters: {
    json: (value) => {
      return JSON.stringify(value, null, 2);
    },
  },
  methods: {
    displayedSize(gift, size) {
      if (
        this.remoteConfig["kidsSizes"] &&
        (this.remoteConfig["kidsSizes"]["giftNames"].includes(gift.name) ||
          this.remoteConfig["kidsSizes"]["giftIds"].includes(gift.id))
      ) {
        return this.remoteConfig["kidsSizes"]["sizes"][size];
      }
      return size;
    },
    openGift(gift) {
      this.gift = Object.assign({}, gift);
      this.size = "";
      this.language = "";
      this.isP2PGift = false;
      this.delivery.agreements.main = false;
      this.delivery.agreements.tax = false;

      this.delivery = Object.assign({}, this.defaultDelivery);
      this.wallet = {
        name: "Default Wallet",
        points: this.currentPoints,
        auth_hash: "default",
      };
      if (
        this.p2pConfig["edu"] &&
        this.p2pConfig["edu"].points >= gift.points &&
        this.currentTab === "education"
      ) {
        this.wallet = {
          name: "Learning Wallet",
          points: this.p2pConfig["edu"].points || 0,
          auth_hash: this.p2pConfig["edu"].auth_hash,
        };
      }

      this.delivery.custom_agreement_text = "";
      if (this.remoteConfig.customAgreement.gifts.includes(gift.id)) {
        this.delivery.agreements.custom = false;
        this.delivery.custom_agreement_text =
          this.remoteConfig.customAgreement.text;
      }
    },
    async getGift(gift) {
      if (this.isRedemptionDisabled(gift)) return;
      let giftObject = gift;

      giftObject.notes = [];
      if (this.isP2PGiftEnabled(gift) && this.isP2PGift) {
        giftObject.notes = giftObject.notes.concat([
          "P2P Gift",
          this.email,
          '"' + this.P2PGiftNote + '"',
        ]);
      }
      giftObject.notes.push(this.delivery.type);
      if (this.delivery.type === "delivery") {
        giftObject.notes = giftObject.notes.concat([
          this.delivery.full_name,
          this.delivery.address,
          String(this.delivery.postal).substring(0, 8),
          this.delivery.city,
          this.delivery.country,
          String(this.delivery.phone).replace(/\D/g, ""),
        ]);
      } else {
        giftObject.notes = giftObject.notes.concat(["", "", "", "", "", ""]);
      }
      if (this.delivery.retiring) {
        giftObject.notes.push(
          "R:" + String(this.delivery.retiringDate).substring(0, 10)
        );
      } else if (this.delivery.vacation) {
        giftObject.notes.push(
          "V:" +
            String(this.delivery.vacationStart).substring(0, 10) +
            " to " +
            String(this.delivery.vacationEnd).substring(0, 10)
        );
      } else {
        giftObject.notes.push("-");
      }
      giftObject.notes.push(
        this.language
          ? this.language + ";" + this.delivery.comment
          : this.delivery.comment
      );
      giftObject.notes = giftObject.notes.join("{joiner}");
      giftObject.notes = giftObject.notes
        .replaceAll("|", "")
        .replaceAll("{joiner}", "|");

      if (this.size) {
        giftObject.dep_id = SIZE_DEPS[this.size];
      }

      if (this.wallet && this.wallet.auth_hash !== "default") {
        giftObject["auth_hash"] = this.wallet.auth_hash;
      }

      if (this.holding) return;
      this.holding = true;
      if (this.isCharity(gift)) {
        await this.$store.dispatch("setVariable", {
          charityAmount: parseInt(this.charity) - 1,
        });
      } else {
        await this.$store.dispatch("setVariable", {
          locationManager: this.locationManager,
          gn: giftObject.name,
        });
      }
      this.$store.dispatch("getGift", giftObject).then(async (res) => {
        this.success = res;
        if (this.isCharity(giftObject)) {
          // Waiting for server to write off points through wehooks
          await new Promise((resolve) => setTimeout(resolve, 4000));
        }
        this.$store.dispatch("fetchUser");
        this.$store.dispatch("fetchHistory");
        this.$store.dispatch("fetchGifts");
        this.$store.dispatch("updateP2PQuest");
        this.holding = false;
      });
    },
    groupedGiftList(tab) {
      if (!this.filteredGiftList) {
        return [];
      }

      let categories = this.filteredGiftList.map((v) => v.category);
      let uniqueCategories = categories
        .filter((value, index, self) => self.indexOf(value) === index)
        .sort((a, b) => {
          let prio_a =
            this.remoteConfig.gifts[a] && this.remoteConfig.gifts[a].priority;
          let prio_b =
            this.remoteConfig.gifts[b] && this.remoteConfig.gifts[b].priority;
          if (prio_a && prio_b) {
            return prio_b - prio_a;
          } else if (prio_a) {
            return -1;
          } else if (prio_b) {
            return 1;
          } else {
            return !a ? 1 : !b ? -1 : b - a;
          }
        });

      let groups =
        uniqueCategories &&
        uniqueCategories.map((category) => {
          return {
            id: category,
            gifts: this.filteredGiftList.filter(
              (gift) => gift.category === category
            ),
          };
        });

      return (
        groups &&
        groups.filter(
          (group) =>
            this.remoteConfig &&
            this.remoteConfig.tabCategories[tab].includes(group.id)
        )
      );
    },
    onScrollTo(id) {
      let element = this.$refs["gift_" + id] || this.$refs["mobile_gift_" + id];
      if (!element) return;
      let rect = element[0].getBoundingClientRect();
      let headerHeight = document.querySelector(".header").clientHeight;
      let offsetY = rect.top + window.pageYOffset - headerHeight;
      if (offsetY !== 0) {
        window.scrollTo(rect.left, offsetY);
      }
    },
    hideGiftPopup() {
      this.gift = null;
      this.success = null;
    },
    isDiscounted(gift) {
      return (
        this.remoteConfig.discountedGifts &&
        this.remoteConfig.discountedGifts.includes(gift.id)
      );
    },
    isDeliveryDisabled(gift) {
            return (
        this.remoteConfig.deliveryDisabledGifts &&
        this.remoteConfig.deliveryDisabledGifts.includes(gift.id)
      );
    },
    isCharity(gift) {
      return (
        this.remoteConfig.charityGifts &&
        this.remoteConfig.charityGifts.includes(gift.id)
      );
    },
    isP2PGiftEnabled(gift) {
      return (
        this.remoteConfig.p2pGifts &&
        this.remoteConfig.p2pGifts.includes(gift.id)
      );
    },
    isNew(gift) {
      return (
        this.remoteConfig.newGifts &&
        this.remoteConfig.newGifts.includes(gift.id)
      );
    },
    isEco(gift) {
      return (
        this.remoteConfig.ecoGifts &&
        this.remoteConfig.ecoGifts.includes(gift.id)
      );
    },
    giftName(gift) {
  const cleanGiftName = gift.name.replace(/<[^>]*>/g, '').trim();

  let locationSpecificChanges =
    this.remoteConfig["giftChangesByLocation"] &&
    this.remoteConfig["giftChangesByLocation"].find((v) =>
      v.locations.includes(this.city)
    );

  if (locationSpecificChanges) {
    if (
      locationSpecificChanges.names &&
      cleanGiftName in locationSpecificChanges.names
    ) {
      return locationSpecificChanges.names[cleanGiftName];
    }
  }

  let managerSpecificChanges =
    this.remoteConfig["giftChangesByManager"] &&
    this.remoteConfig["giftChangesByManager"].find((v) =>
      v.managers.includes(this.locationManager)
    );

  if (managerSpecificChanges) {
    if (
      managerSpecificChanges.names &&
      cleanGiftName in managerSpecificChanges.names
    ) {
      return managerSpecificChanges.names[cleanGiftName];
    }
  }

  let name = gift.name.split("[")[0];
  name = name.replace(/<[^>]*>/g, '').trim();
  return name;
},


    giftPlaque(gift) {
        let name = gift.name
        const pattern = /<(.*?)>/;
        const match = name.match(pattern);
        return match ? match[1] : null;
    },

giftImage(gift) {
  const cleanGiftName = gift.name.replace(/<[^>]*>/g, '').trim();

  let locationSpecificChanges =
    this.remoteConfig["giftChangesByLocation"] &&
    this.remoteConfig["giftChangesByLocation"].find((v) =>
      v.locations.includes(this.city)
    );

  if (locationSpecificChanges) {
    if (
      locationSpecificChanges.images &&
      cleanGiftName in locationSpecificChanges.images
    ) {
      return locationSpecificChanges.images[cleanGiftName];
    }
  }

  let managerSpecificChanges =
    this.remoteConfig["giftChangesByManager"] &&
    this.remoteConfig["giftChangesByManager"].find((v) =>
      v.managers.includes(this.locationManager)
    );
  
  if (managerSpecificChanges) {
    if (
      managerSpecificChanges.images &&
      cleanGiftName in managerSpecificChanges.images
    ) {
      return managerSpecificChanges.images[cleanGiftName];
    }
  }

  return gift.image;
},

    isRedemptionDisabled(gift) {
      let charityOk = true;
      let p2pOk = true;
      let sizeOk = true;
      let deliveryDisabled = this.isDeliveryDisabled(gift) || this.isCharity(gift)

      if (this.isCharity(gift)) {
        charityOk = this.charity >= 1 && this.charity <= this.currentPoints;
      }
      if (this.isP2PGiftEnabled(gift) && this.isP2PGift) {
        p2pOk =
          this.email && this.validationStatus === "ok" && this.P2PGiftNote;
      }
      if (this.remoteConfig && this.remoteConfig.sizedGifts.includes(gift.id)) {
        sizeOk = this.size;
      }

      let delivery = this.delivery;
      let deliveryOk = deliveryDisabled
        ? true
        : this.agreement &&
          (delivery.type === "pickup" ||
            (delivery.type === "delivery" &&
              delivery.full_name &&
              delivery.address &&
              delivery.postal &&
              delivery.city &&
              delivery.country &&
              delivery.phone)) &&
          (!delivery.retiring || delivery.retiringDate) &&
          (!delivery.vacation ||
            (delivery.vacationStart && delivery.vacationEnd));

      return !(charityOk && p2pOk && sizeOk && deliveryOk);
    },

    isEnoughPoints(gift) {
      if (!this.wallet) {
        return this.currentPoints >= gift.points;
      } else {
        return this.wallet.points >= gift.points;
      }
    },

    onInput() {
      let cachedEmail = this.email;
      this.validationStatus = "none";
      setTimeout(() => {
        if (this.email === cachedEmail) {
          this.checkEmail();
        }
      }, 500);
    },
    checkEmail() {
      let auth_hash = this.p2pConfig["p2p"].auth_hash;
      if (!auth_hash || !this.email) {
        return;
      }
      this.$jsonp(
        `https://luxoft.sailplay.com/js-api/1954/users/search/?auth_hash=${auth_hash}&email=${encodeURIComponent(
          this.email
        )}`
      ).then((data) => {
        this.validationStatus =
          this.currentUser.email === this.email ? "error" : data && data.status;
        if (this.validationStatus === "ok") {
          this.userId = data.id;
        }
      });
    },
  },
  mounted() {
    this.isMounted = true;
    if (window.innerWidth < 1024) {
      this.isMobile = true;
    }
    this.$eventBus.$on("giftOpen", this.onScrollTo);

    let initedPopup = urlParams.getUrlParameter("p");

    if (initedPopup === "terms") {
      this.isOpenPopup = true;
    }

    this.defaultDelivery = Object.assign({}, this.delivery);
  },
  watch: {
    isOpenPopup(value) {
      let className = "lock-scroll";
      if (value) {
        document.getElementsByTagName("body")[0].style.top =
          -document.documentElement.scrollTop + "px";
        document.documentElement.classList.add(className);
      } else {
        document.documentElement.classList.remove(className);
        document.documentElement.scrollTop = -parseFloat(
          document.getElementsByTagName("body")[0].style.top.replace("px", "")
        );
      }
    },
    isOpenFaq(value) {
      /*
      let className = "lock-scroll";
      if (value) {
        document.getElementsByTagName("body")[0].style.top =
          -document.documentElement.scrollTop + "px";
        document.documentElement.classList.add(className);
      } else {
        document.documentElement.classList.remove(className);
        document.documentElement.scrollTop = -parseFloat(
          document.getElementsByTagName("body")[0].style.top.replace("px", "")
        );
      }*/
    },

    gift(value) {
      let className = "lock-scroll";
      if (value) {
        document.getElementsByTagName("body")[0].style.top =
          -document.documentElement.scrollTop + "px";
        document.documentElement.classList.add(className);
      } else {
        document.documentElement.classList.remove(className);
        document.documentElement.scrollTop = -parseFloat(
          document.getElementsByTagName("body")[0].style.top.replace("px", "")
        );
      }
    },
  },
};
</script>
